module.exports = __webpack_public_path__ + "resources/img/img_logo_clovergames_pc_kr.fcc09f1770b6bae1d2e7cd63a91db2c8.png";